(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfNoOptions', function() {
    return {
      restrict: 'A',
      require: 'uiSelect',
      link: (function(_this) {
        return function(scope, element, attrs, uiSelect) {
          var no_options, unwatch;
          no_options = attrs.mfNoOptions || 'No options';
          return unwatch = scope.$watch('$select.placeholder', function(placeholder) {
            var array_name, junk, original_placeholder, ref, repeat_attr;
            if (placeholder) {
              unwatch();
              original_placeholder = placeholder;
              repeat_attr = $(element.find('.ui-select-choices')[0]).attr('repeat');
              ref = repeat_attr.match(/\s+in\s+(\S+)/), junk = ref[0], array_name = ref[1];
              return scope.$parent.$watchCollection(array_name, function(items) {
                if (((items != null) && !items.length) || (items == null)) {
                  return scope.$select.placeholder = no_options;
                } else {
                  return scope.$select.placeholder = original_placeholder;
                }
              });
            }
          });
        };
      })(this)
    };
  });

}).call(this);
